import React, { useEffect, useState } from "react";
import base_url from "../../base_url";
import {localStorageUserKey} from '../../local_storage_vars';
import { smartStorage } from "../../smart_storage";
import Select from 'react-select';
import axios from "axios";
import { Spinner } from "react-activity";

import { Elements } from '@stripe/react-stripe-js';
import { stripePromise } from '../../stripe';
import CheckoutForm from './CheckoutForm';

  export default function OfferContainer({message, decodedTokenRef, acceptingOfferLoading, services, socket, selectedChat, payment_accounts}){
    const [workNeeded, setWorkNeeded] = useState(message.work_need_done);
    const [downPayment,setDownPayment] = useState(message?.down_payment)
    const [finalPayment,setFinalPayment] = useState(message?.final_payment) 
    const [offer_message,setMessage] = useState(message?.message)
   
    const [accept_offer_loading,setAcceptOfferLoading] = useState(false)

    const appearance = { theme: 'stripe' };
    const options = { appearance };
    const base_url = process.env.REACT_APP_BASE_URL;

    const fetchOfferDetails = async(offer_id)=>{
      const user = await smartStorage.get(localStorageUserKey); 

       axios.get(`${base_url}/apis/message/offer-details?offer_id=${offer_id}`,{
           headers: {
             "x-api-key": process.env.REACT_APP_API_KEY,
             "authorization": user,
             'Content-Type': 'application/json', 
           }})
       .then(res=>{
           setDownPayment(res.data.down_payment)
           setFinalPayment(res.data.final_payment)
           setMessage(res.data.message)
           setWorkNeeded(res.data.work_need_done)
       })
       .catch(err=>{
           alert(err.message)
       })
     }



    useEffect(()=>{
      socket.on('offer_updated',(data)=>{
        if(data.offer_id == message._id){
          fetchOfferDetails(data.offer_id)
        }
      })
    },[socket])


    
    return(
        <>

        <div className="offer_message mt-2" >
        <div className="d-flex align-items-center border" style={{backgroundColor:'#007aff',padding:5,borderRadius:5}}>
          
          
          <a href={`/contractor_profile/${message.sender_user[0]?._id}`}><strong style={{ color: 'white' }}>
            <img
              src={message.sender_user[0]?.profile_picture?message.sender_user[0]?.profile_picture:require('../../assets/user-circle.png')}
              style={{ width: 30, height: 30, borderRadius: '50%', marginRight: '10px' }}
              alt="User Profile"
            />
            {message.sender_user[0]?._id == decodedTokenRef.current._id? 'Me':message.sender_user[0]?.username}
          </strong>
          </a>
          <span className="ml-auto small" style={{color:'#3292f8ff'}}>
            {message.sender_user[0]?.connectedAccountId}
          </span>
          
          <span className="ml-auto small" style={{color:'white'}}>
            {new Date(message.createdAt).toLocaleString()}
          </span>
          
        </div>

       {decodedTokenRef.current?.user_type === "contractor" && message.is_accepted == false?<button onClick={()=>window.location=`/edit_offer/${message._id}`} className='btn btn-primary float-right' >Edit</button>:null}
          
          <br />
          <h4>{message.job[0]? message.job[0].name:message.job_title}</h4>
          <b style={{ color: 'black' }}>Handyman Offer: </b>
          <br />
          <span className="float-left">{offer_message}</span>
          <br />
          <span><b style={{ color: 'black' }}>Down Payment:</b> ${downPayment}</span>
          <br />
          <span><b style={{ color: 'black' }}>Final Payment:</b> ${finalPayment}</span>
          <br />
          <span><b style={{ color: 'black' }}>Services: </b>{workNeeded}</span>

          {decodedTokenRef.current != null && decodedTokenRef.current?.user_type === "client" ? (
            <center>

          
              {/* <button disabled={message.is_accepted || acceptingOfferLoading} onClick={pay_for_offer}  
                      className='btn btn-success' 
                      style={{ width: '100%', marginTop: 20, marginBottom: 20 }}>
                        {acceptingOfferLoading?<Spinner color="skyblue" size={25}/>:null}
                        {accept_offer_loading?<Spinner color="skyblue" size={20}/>:null}
                        {message.is_accepted === false ? 'Accept offer' : 'Accepted'}
              </button> */}

              {message.is_accepted && 
              <button className='btn btn-success' disabled={message.is_accepted}
                      style={{ width: '100%', marginTop: 20, marginBottom: 20 }}>Accepted
              </button>}

              {!message.is_accepted &&
               message.sender_user[0]?.connectedAccountId &&
                <div className="border p-2 btn-success col-12 col-sm-12 col-md-12 col-lg-6 mt-3" 
                style={{width:'100%', borderRadius:5, color:'white', alignItems:'center',justifyContent:'center', 
                  display:'inline-flex', flexDirection:'column', marginTop:10, marginBottom:10}}> 
                    <Elements stripe={stripePromise} options={options}>
                      <h5>Pay Handyman to Accept this Offer</h5>
                      <small style={{color:'white'}}>This offer will expire in 3 days</small>
                        <div className='p-2' 
                              style={{width:'100%', backgroundColor:'white', padding:10, borderRadius:5, alignItems:'center', justifyContent:'center', 
                              display:'inline'}}> 
                      <CheckoutForm offerId={message._id} 
                                    handymanAccountId={message.sender_user[0]?.connectedAccountId} 
                                    amount={downPayment*100} 
                                    handymanCommissionPercentage={Number(message.sender_user[0]?.contractorEntity.retailer_percentage.$numberDecimal)} 
                                    reason='create_order' /></div>
                    </Elements>
                </div>
                }
            </center>
          ) : (
            <div style={{ width: '100%', marginTop: 20, marginBottom: 20, borderRadius: 5, padding: 10, alignItems: 'center', justifyContent: 'center', display: 'flex', backgroundColor: '#D3D3D3' }} className='border'>
              {message.is_accepted === false ? 'Waiting For Response' : 'Accepted'}
            </div>
          )}
        </div>
          <br />
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <hr style={{ width: '80%' }} />
            <div style={{ position: 'relative', top: '-30px', backgroundColor: 'white', padding: '0 10px',fontWeight:'bold' }}>{message.job[0]? message.job[0].name:message.job_title}</div>
          </div>

        </>

    )
}